import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type LtClientsState = {
  selectedClientId: string | null
}

const initialState: LtClientsState = {
  selectedClientId: null,
}

const ltClient = createSlice({
  name: 'ltClient',
  initialState,
  reducers: {
    setSelectedClientId: (state, action: PayloadAction<string | null>) => {
      state.selectedClientId = action.payload
    },
    clearSelectedClientId: (state) => {
      state.selectedClientId = null
    },
  },
})

export const { setSelectedClientId, clearSelectedClientId } = ltClient.actions
export default ltClient.reducer
